import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";
import { components, GroupBase, MenuProps } from "react-select";

import { useIsModal } from "@/components/General/Modal/context/modal.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { AutocompleteAddress } from "@/services/bpost.service";

type MenuComponentProps = MenuProps<
    AutocompleteAddress,
    false,
    GroupBase<AutocompleteAddress>
>;

type ExtraProps = {
    onManualEntry: () => void;
};

type BPostAddressFieldMenuComponentProps = MenuComponentProps & ExtraProps;

export const BPostAddressFieldMenuComponent = ({
    onManualEntry,
    ...props
}: BPostAddressFieldMenuComponentProps) => {
    const { t } = useGranite();

    const handleOnClick = (event: MouseEvent) => {
        event.preventDefault();
        onManualEntry();
    };

    return (
        <components.Menu {...props}>
            {props.children}
            <a
                className={cn(
                    "tw:cursor-pointer tw:block tw:bg-grey tw:underline tw:p-2"
                )}
                href="#"
                onClick={handleOnClick}
            >
                {t("bPostAddressField.label.addressNotFound")}
            </a>
        </components.Menu>
    );
};

export const createBPostAddressFieldMenuComponent =
    (extraProps: ExtraProps) => (props: MenuComponentProps) => {
        const isModal = useIsModal();

        return (
            <BPostAddressFieldMenuComponent
                {...props}
                {...extraProps}
                className={cn(props.className, {
                    "tw:relative! tw:overflow-hidden!": isModal
                })}
            />
        );
    };
